'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2016/9/12.
                                          */

// import { Link } from 'react-router';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _myCommissions = require('redux/modules/myCommissions');

var myCommissionsActions = _interopRequireWildcard(_myCommissions);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyCommissions = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var location = _ref.location;

    var promises = [];
    promises.push(dispatch(myCommissionsActions.load(location.query)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.myCommissions.data,
    dataError: state.myCommissions.error
  };
}, (0, _extends3.default)({}, myCommissionsActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MyCommissions, _Component);

  function MyCommissions() {
    (0, _classCallCheck3.default)(this, MyCommissions);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(MyCommissions).call(this));

    _this.state = {
      orderItem: '',
      direction: '',
      filter: '',
      currentPage: 0
    };
    return _this;
  }

  (0, _createClass3.default)(MyCommissions, [{
    key: 'onItemClick',
    value: function onItemClick(clickItem) {
      var load = this.props.load;
      var _state = this.state;
      var direction = _state.direction;
      var filter = _state.filter;

      var currentDirection = 'ASC';
      var currentFilter = filter;
      // console.log(clickItem);
      switch (clickItem) {
        case 'shop':
        case 'buymoney':
        case 'time':
        case 'commissions':
        case 'commissionRate':
          if (direction === 'ASC') {
            currentDirection = 'DESC';
          }
          this.setState({
            orderItem: clickItem,
            direction: currentDirection
          });
          break;
        default:
          this.setState({
            filter: '',
            orderItem: '',
            direction: ''
          });
          currentFilter = '';
          currentDirection = '';
          break;
      }
      if (load) {
        load(currentFilter, 0, { orderItem: clickItem, direction: currentDirection });
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch() {
      var load = this.props.load;

      var value = this.refs.searchInput.value;
      var _state2 = this.state;
      var orderItem = _state2.orderItem;
      var direction = _state2.direction;
      var filter = _state2.filter;

      if (load) {
        var currentFilter = filter;
        if (value && value !== '') {
          currentFilter = (0, _extends3.default)({}, filter, { FindValue: value });
        } else {
          delete currentFilter.FindValue;
        }
        this.setState({
          filter: currentFilter
        });
        load(currentFilter, 0, { orderItem: orderItem, direction: direction });
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var load = this.props.load;
      var _state3 = this.state;
      var orderItem = _state3.orderItem;
      var direction = _state3.direction;
      var filter = _state3.filter;

      if (load) {
        this.setState({
          currentPage: page
        });
        load(filter, page, { orderItem: orderItem, direction: direction });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./MyCommissions.scss');
      var data = this.props.data;
      var _state4 = this.state;
      var currentPage = _state4.currentPage;
      var orderItem = _state4.orderItem;

      var myCommissionsShow = '';
      var myCommissionsSummarizeShow = '';
      var errorLabel = '';
      var totalPageNumber = 1;
      if (data) {
        var myCommissions = data.myCommissions;
        var myCommissionsError = data.myCommissionsError;
        var myCommissionsSummarize = data.myCommissionsSummarize;
        var myCommissionsSummarizeError = data.myCommissionsSummarizeError;
        var myCommissionsRecordCount = data.myCommissionsRecordCount;
        var myCommissionsPagesize = data.myCommissionsPagesize;

        if (myCommissionsError || myCommissionsSummarizeError) {
          errorLabel = _react2.default.createElement(_components.ErrorLabel, { error: myCommissionsError || myCommissionsSummarizeError });
        }

        if (myCommissions instanceof Array && myCommissions.length > 0) {
          myCommissionsShow = _react2.default.createElement(_components.MyCommissionsComponent, { commissions: myCommissions,
            onItemClick: this.onItemClick.bind(this),
            onSearch: this.onSearch.bind(this) });
          totalPageNumber = parseInt(myCommissionsRecordCount / myCommissionsPagesize, 10);
          if (myCommissionsRecordCount % myCommissionsPagesize > 0) {
            ++totalPageNumber;
          }
        }

        if (myCommissionsSummarize instanceof Array && myCommissionsSummarize.length > 0) {
          myCommissionsSummarizeShow = _react2.default.createElement(
            'div',
            { className: styles.summ },
            _react2.default.createElement(
              'div',
              { className: styles.sqtxt1 },
              '截止日期：',
              myCommissionsSummarize[0].deadlines
            ),
            _react2.default.createElement(
              'div',
              { className: styles.sqtxt2 },
              '佣金总额：¥',
              _react2.default.createElement(
                'span',
                { style: { marginRight: 25 } },
                myCommissionsSummarize[0].totalCommissions
              ),
              '可提现总额：¥',
              _react2.default.createElement(
                'span',
                null,
                myCommissionsSummarize[0].withdrawCommissions
              )
            )
          );
        }
      }
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        myCommissionsSummarizeShow,
        _react2.default.createElement(
          'ul',
          { className: styles.jsdd },
          _react2.default.createElement(
            'li',
            { className: orderItem === '' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('');
              } },
            '全部'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'shop' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('shop');
              } },
            '店铺'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'buymoney' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('buymoney');
              } },
            '购买金额'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'time' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('time');
              } },
            '购买时间'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'commissionRate' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('commissionRate');
              } },
            '佣金比例'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'commissions' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('commissions');
              } },
            '佣金'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.jsallshou },
          _react2.default.createElement('input', { ref: 'searchInput', type: 'text' }),
          _react2.default.createElement(
            'div',
            { onClick: this.onSearch.bind(this) },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/shc.png', alt: '', className: 'img' })
          )
        ),
        _react2.default.createElement(
          'table',
          { className: styles.allTable },
          _react2.default.createElement(
            'colgroup',
            null,
            _react2.default.createElement('col', { width: '6%' }),
            _react2.default.createElement('col', { width: '10%' }),
            _react2.default.createElement('col', { width: '21%' }),
            _react2.default.createElement('col', { width: '21%' }),
            _react2.default.createElement('col', { width: '12%' }),
            _react2.default.createElement('col', { width: '10%' }),
            _react2.default.createElement('col', { width: '10%' }),
            _react2.default.createElement('col', { width: '10%' })
          ),
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                '序号'
              ),
              _react2.default.createElement(
                'th',
                null,
                '姓名'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买艺品'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买店铺'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买时间'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买金额'
              ),
              _react2.default.createElement(
                'th',
                null,
                '佣金比例'
              ),
              _react2.default.createElement(
                'th',
                null,
                '佣金'
              )
            )
          ),
          myCommissionsShow
        ),
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { selected: currentPage, totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : '',
        errorLabel
      );
    }
  }]);
  return MyCommissions;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  load: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = MyCommissions;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/MyCommissions/MyCommissions.js
 ** module id = 1498
 ** module chunks = 0
 **/